import React from 'react';
import { IntlProvider } from 'react-intl';
import { useMemo } from 'react';
import { useAuth } from './auth';
import { resolveLanguage } from '../utils/locale';
import ptBRTranslation from '../translations/pt-BR.json';
import ptPTTranslation from '../translations/pt-PT.json';
import enTranslation from '../translations/en.json';
import esTranslation from '../translations/es.json';

const I18nProvider: React.FC = ({ children }) => {
  const { user } = useAuth();

  const language = useMemo(() => resolveLanguage(user?.language), [user]);

  const messages = useMemo(() => {
    const translations = {
      'pt-BR': ptBRTranslation,
      'pt-PT': ptPTTranslation,
      'en': enTranslation,
      'es': esTranslation,
    };
    return translations[language];
  }, [language]);

  return (
    <IntlProvider locale={language} messages={messages}>
      {children}
    </IntlProvider>
  );
};

export { I18nProvider };
